//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet, axiosPost } from '../../../axios/axios.js'
import { mapGetters } from 'vuex'
import { formatConfiguredTime, getPhoneHref, formatTime } from '../../../components/helpers.js'
import moment from 'moment'

import { createFieldConfig, Store } from '../../../components/QSelectUtils.js'
import DateTimeField from '../../../components/Field/DateTimeField.vue'
import ItemsSearchField from '../../../components/Field/ItemsSearchField.vue'
import AddressField from '../../../components/Field/AddressField.vue'
import BrigadeForkliftTruckFieldTable from '../../../forms/Brigade/BrigadeForkliftTruck/BrigadeForkliftTruckFieldTable.vue'
import FilesField from '../../../components/File/FilesField.vue'
import { checkVehicleGroupTypeManagementAccess, createVehicleGroupType } from '../../VehicleGroupType/VehicleGroupType.js'
import { createProvidableVehicle } from '../../../forms/Vehicle/Vehicle.js'
import { createProvidableDriver } from '../../../pages/main/sections/VehicleProvision/ProvidableDriver.js'

export default {
  components: {
    FilesField,
    ItemsSearchField,
    DateTimeField,
    AddressField
  },
  props: {
    vehicleProvision: {
      type: Object,
      default: () => {
        return {}
      }
    },
    bp: {
      type: Object,
      default: () => {
        return {}
      }
    },
    request: {
      type: Object,
      default: () => {
        return {}
      }
    },
    report: {
      type: Object,
      default: () => {
        return {}
      }
    },
    requestProperties: {
      type: Object,
      default: () => {
        return {}
      }
    },
    interval: {
      type: Object,
      default: () => {
        return {}
      }
    },
    assignedBrigade: {
      type: Object,
      default: null
    },
    mobile: {
      type: Boolean,
      default: false
    },
    isCreate: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      driverCreateOpened: false,
      vehicleIntervalRequests: this.bp.vehicleIntervalRequests || [],

      replacingRequestFieldConfig: createFieldConfig(new Store({
        fullReadable: false,
        searchable: false,
        cached: false,
        proxy: {
          urlBase: '/service/delta/vehicleProvision/searchReplacement',
          urlParams: {
            request: this.request.id,
            replacing: true
          },
          filterType: 'vehicleProvisionRequest',
          formId: 'searchReplacement',
          mapper: vehicleProvision => vehicleProvision.request
        }
      })),
      replacementRequestFieldConfig: createFieldConfig(new Store({
        fullReadable: false,
        searchable: false,
        cached: false,
        proxy: {
          urlBase: '/service/delta/vehicleProvision/searchReplacement',
          urlParams: {
            request: this.request.id,
            replacing: false
          },
          filterType: 'vehicleProvisionRequest',
          formId: 'searchReplacement',
          mapper: vehicleProvision => vehicleProvision.request
        }
      })),
      requestColumns: [
        {
          name: 'name',
          label: 'Название',
          align: 'left',
          field: row => row,
          sortable: true,
          columnFormat: 'object',
          columnObjectType: 'vehicleProvision'
        },
        {
          name: 'vehicle',
          label: 'ТС',
          align: 'left',
          field: row => row.vehicle ? row.vehicle.gosNumber : '',
          sortable: false
        },
        {
          name: 'serviceTimeAgreed',
          label: 'Согласованное время подачи ТС',
          labelTable: 'Согласованное время<br/>подачи ТС',
          align: 'left',
          field: row => row.serviceTimeAgreed,
          sortable: true,
          format: formatTime
        },
        {
          name: 'serviceEndTimeRequired',
          label: 'Плановое время сдачи ТС',
          labelTable: 'Плановое время<br/>сдачи ТС',
          align: 'left',
          field: row => row.serviceEndTimeRequired,
          sortable: true,
          format: formatTime
        }
      ],
      organizationFieldConfig: createFieldConfig({ allRecordsFn: this.getOrganizations }),
      vehicleTypeFieldConfig: createFieldConfig({ allRecordsFn: this.getVehicleTypes }),
      vehicleGroupTypeFieldConfig: createFieldConfig({ allRecordsFn: this.getVehicleGroupTypes }),
      workAreaFieldConfig: createFieldConfig({ allRecordsFn: this.getWorkAreas }),
      serviceTypeFieldConfig: createFieldConfig({ allRecordsFn: this.getServiceTypes }),
      vehicleFieldConfig: createFieldConfig({ allRecordsFn: this.getVehicles }),
      driverFieldConfig: createFieldConfig({ allRecordsFn: this.getDrivers }),

      plannedProjectFieldConfig: createFieldConfig(new Store({
        itemsFn: this.getProjects,
        cached: false,
        storeType: 'server',
        fullReadable: true,
        searchable: true,
        searchFiltrationBySource: false,
        searchValueMinLength: 0
      })),
      plannedProjectColumns: [
        {
          name: 'name',
          label: 'Название',
          align: 'left',
          field: 'name',
          searchable: true, // !!!
          sortable: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters({
      getWorkShifts: 'getWorkShifts'
    }),
    workShifts: function () {
      return this.getWorkShifts.filter(wS => wS.active)
    },
    vehicleGroupTypeManagementAccess: function () {
      const user = this.$store.getters.getUser
      return checkVehicleGroupTypeManagementAccess(user)
    },
    maxServiceDuration: {
      get: function () {
        return this.request.maxServiceDuration != null ? this.request.maxServiceDuration / (1000 * 60 * 60) : null
      },
      set: function (value) {
        this.request.maxServiceDuration = null

        if (value != null) {
          this.request.maxServiceDuration = value * 1000 * 60 * 60
        }
      }
    },
    serviceDurationRequired: {
      get: function () {
        return this.request.serviceDurationRequired != null ? Math.floor(this.request.serviceDurationRequired / (1000 * 60 * 60)) : null
      },
      set: function (value) {
        this.request.serviceDurationRequired = null

        if (value != null) {
          this.request.serviceDurationRequired = value * 1000 * 60 * 60
        }
      }
    },
    addressAdditionalObjectTypes: function () {
      if (this.assignedBrigade && this.assignedBrigade.brigadeId) {
        return [
          { key: 'request', name: `Заявка бригады ${this.assignedBrigade.brigadeName}`, url: `/service/delta/brigade/queueRequestsAddresses?id=${this.assignedBrigade.brigadeId}` }
        ]
      } else {
        return []
      }
    },
    phoneHref: function () {
      if (this.request.driver) {
        return getPhoneHref(this.request.driver.phone)
      }
      return null
    },
    mismatchTimes: function () {
      return this.request.serviceTimeAgreed && this.request.serviceTimeRequired && (Math.floor(this.request.serviceTimeAgreed / 60000)) !== (Math.floor(this.request.serviceTimeRequired / 60000))
    },
    serviceTimeRequiredOptions: function () {
      let date = new Date()
      if (this.request.createTime) {
        date = this.request.createTime
      }
      return this.getMatchedWorkShifts(date, true)
    },
    serviceEndTimeRequiredOptions: function () {
      let date = new Date().getTime()
      if (this.request.serviceTimeRequired) {
        date = this.request.serviceTimeRequired
      }
      return this.getMatchedWorkShifts(date, false)
    },
    crewSizePlaceholder: function () {
      let defaultCount = null
      if (this.request.vehicleGroupProvision) {
        const vehicleGroupType = this.request.vehicleGroupType
        if (vehicleGroupType && vehicleGroupType.vehiclesCount != null) {
          defaultCount = vehicleGroupType.vehiclesCount
        }
      } else {
        const vehicle = this.request.vehicle
        if (vehicle) {
          defaultCount = vehicle.crewSize || 1
        }
      }
      if (defaultCount != null) {
        return '' + defaultCount + ' (по умолчанию)'
      }
      return null
    },
    readyDocumentFilesGroup: function () {
      if (this.request && this.request._filesGroups) {
        return this.request._filesGroups.getFilesGroup('readyDocument')
      }
      return null
    },
    readyDocumentAccessProps: function () {
      const requestProperty = this.requestProperties.readyDocument
      return requestProperty && requestProperty.accessProps || {}
    }
  },
  watch: {
    'request.serviceTimeRequired': function (val) {
      if (this.request.serviceEndRequiredByDuration && this.request.serviceDurationRequired) {
        this.request.serviceEndTimeRequired = this.request.serviceTimeRequired + this.request.serviceDurationRequired
        this.validateFields(['serviceEndTimeRequired'])
      } else if (this.request.serviceEndTimeRequired) {
        this.request.serviceDurationRequired = this.request.serviceEndTimeRequired - this.request.serviceTimeRequired
        this.validateFields(['serviceDurationRequired'])
      }

      if (this.request.routePoints && this.request.routePoints[0]) {
        const firstPoint = this.request.routePoints[0]
        if (!this.request.serviceTimeAgreed) {
          firstPoint.plannedStartTime = this.request.serviceTimeRequired
        }
      }
    },
    'request.serviceTimeAgreed': function (val) {
      if (this.request.routePoints && this.request.routePoints[0]) {
        const firstPoint = this.request.routePoints[0]
        if (this.request.serviceTimeAgreed) {
          firstPoint.plannedStartTime = this.request.serviceTimeAgreed
        } else {
          firstPoint.plannedStartTime = this.request.serviceTimeRequired
        }
      }
    },
    'request.address': function (val) {
      if (this.request.routePoints && this.request.routePoints[0]) {
        const firstPoint = this.request.routePoints[0]
        firstPoint.sourcedAddress = this.request.address
      }
    },
    'request.serviceEndTimeRequired': function (val) {
      this.request.serviceDurationRequired = this.request.serviceEndTimeRequired - this.request.serviceTimeRequired
      this.validateFields(['serviceDurationRequired'])
    },
    serviceDurationRequired: function (val) {
      this.request.serviceEndTimeRequired = this.request.serviceTimeRequired + this.request.serviceDurationRequired
      this.validateFields(['serviceEndTimeRequired'])
    },
    'request.serviceType': function (val) {
      if (!this.request.serviceType) {
        this.maxServiceDuration = null
      } else if (this.request.serviceType.id === 'for24h' && !this.maxServiceDuration) {
        this.maxServiceDuration = 24
      }
      this.validateFields(['maxServiceDuration'])
    },
    interval: {
      handler: function (val) {
        if (val) {
          this.getValidateVehicleIntervalRequests()
        }
      },
      deep: true
    },
    'request.vehicle': {
      handler: function (val) {
        if (val) {
          this.getValidateVehicleIntervalRequests()
        }
      },
      deep: true
    }
  },
  methods: {
    onFileRemove: function ({ file: fileWrapper, filesGroup }) {
      filesGroup.removeFile(fileWrapper)
    },
    onSelectReplacingRequest: function (vehicleProvisionRequest) {
    },
    onSelectReplacementRequest: function (vehicleProvisionRequest) {
    },
    getWorkShiftLabelFromDate: function (dateMs, start = true) {
      let options = []
      if (start) {
        options = this.serviceTimeRequiredOptions
      } else {
        options = this.serviceEndTimeRequiredOptions
      }
      const workShift = options.find(wS => {
        if (start) {
          return wS.start === dateMs
        } else {
          return wS.end === dateMs
        }
      })

      if (workShift) {
        return this.getWorkShiftLabel(workShift, workShift.date, start)
      } else {
        let date = new Date(dateMs)
        const workShift = this.workShifts.find(wS => {
          if (start) {
            return wS.startHour === date.getHours()
          } else {
            return wS.endHour % 24 === date.getHours()
          }
        })
        if (workShift) {
          if (!start) {
            date = moment(date).subtract(workShift.endHour, 'hours').toDate()
          }
          date.setHours(0, 0, 0, 0)
          return this.getWorkShiftLabel(workShift, date.getTime(), start)
        }
      }
    },
    getMatchedWorkShifts: function (dateMs, start = true) {
      const hour = new Date(dateMs).getHours()
      const workShifts = []

      this.workShifts.forEach(wS => {
        const date = new Date(dateMs)
        date.setHours(0, 0, 0, 0)
        const nextDate = new Date(date)
        nextDate.setDate(nextDate.getDate() + 1)

        if (wS.startHour >= hour) {
          workShifts.push({ ...wS, date: date.getTime(), label: this.getWorkShiftLabel(wS, date.getTime(), start), start: date.setHours(wS.startHour), end: date.setHours(wS.endHour) })
        } else {
          workShifts.push({ ...wS, date: nextDate.getTime(), label: this.getWorkShiftLabel(wS, nextDate.getTime(), start), start: nextDate.setHours(wS.startHour), end: nextDate.setHours(wS.endHour) })
        }
      })

      if (this.request.serviceTimeRequired) {
        workShifts.filter(ws => {
          if (!start) {
            return ws.end <= this.request.serviceTimeRequired + 24 * 60 * 60 * 1000
          }
        })
      }

      workShifts.sort((a, b) => {
        if (start) {
          return a.start - b.start
        } else {
          return a.end - b.end
        }
      })
      return workShifts
    },
    getWorkShiftLabel: function (ws, dateMs, start = true) {
      let label = ''
      const dateAlias = formatConfiguredTime(dateMs, { month: true, date: true })
      if (start) {
        label += 'Начало '
      } else {
        label += 'Окончание '
      }
      label += `«${ws.name}» (${dateAlias})`
      return label
    },
    onSelectServiceEndTimeRequired: function (wS) {
      if (wS) {
        this.request.serviceEndTimeRequired = wS.end
      }
    },
    onSelectServiceTimeRequired: function (wS) {
      if (wS) {
        this.request.serviceTimeRequired = wS.start
        this.request.serviceEndTimeRequired = wS.end
      }
    },
    openValidateVehicleIntervalRequests: function () {
      this.$d.dialog(this).show({
        maximized: false,
        class: 'brigade-forklift-truck-table--dialog',
        headerLabel: 'Незакрытые заявки на данное ТС',
        contentComponent: BrigadeForkliftTruckFieldTable,
        contentProps: {
          forkliftTruckRequests: this.vehicleIntervalRequests,
          readonly: false,
          create: false
        }
      })
    },
    onOpenCard: function (event, object, type, subtypeKey) {
      if (object.id && type) {
        this.$d_showObjectCard(object.id, type, event.ctrlKey, false, subtypeKey)
      }
    },
    onCall: function (e) {
      e.navigate = false
      this.onClickLink(this.phoneHref)
    },
    onClickLink: function (href) {
      if (href) {
        const a = document.createElement('a')
        a.href = href
        a.click()
      }
    },
    openCreateEmployeeCard: function () {
      const request = this.request

      const objectParams = {}
      if (request.organization) {
        objectParams.contractOrganization = request.organization.id
      }

      const createConfig = {
        actualContractorReadonly: true,
        objectParams
      }
      createProvidableDriver(this, createConfig, this.onDriverCreated)
    },
    openCreateVehicleCard: function () {
      const request = this.request

      const objectParams = {}
      objectParams.inUse = true
      if (request.organization) {
        objectParams.organization = request.organization.id
      }
      if (request.vehicleType) {
        objectParams.vehicleType = request.vehicleType.id
      }

      const createConfig = { objectParams }
      createProvidableVehicle(this, createConfig, this.onVehicleCreated)
    },
    onSelectVehicleType: function (vehicleType) {
      this.clearVehicle()
      if (vehicleType) {
        this.request.providableToBrigade = vehicleType.providableToBrigade
      }
    },
    onSelectVehicleGroupType: function (vehicleGroupType) {
      const request = this.request

      const isNew = request.id == null || request.id === -1
      if (!isNew) {
        this.$emit('update-by-changes', {
          request: {
            vehicleGroupProvision: request.vehicleGroupProvision,
            vehicleGroupType: vehicleGroupType ? vehicleGroupType.id : null
          }
        })
      }

      if (vehicleGroupType) {
        const crewSizeReadonly = this.requestProperties.crewSize.accessProps.readonly
        if (!crewSizeReadonly) {
          const crewSize = vehicleGroupType.vehiclesCount || null
          if (request.crewSize != null && request.crewSize !== crewSize) {
            const warnings = []
            if (crewSize != null) {
              warnings.push('Изменить численность экипажа для группы ТС?')
            } else {
              warnings.push('Сбросить численность экипажа для группы ТС?')
            }
            warnings.push('Прежнее значение: ' + request.crewSize)
            if (crewSize != null) {
              warnings.push('Предлагаемое значение: ' + crewSize)
            }

            this.$d_ask({
              callback: (data, action) => {
                if (action === 'yes') {
                  request.crewSize = crewSize
                }
              },
              warning: warnings,
              buttons: [
                { key: 'yes', name: crewSize != null ? 'Изменить' : 'Сбросить', color: 'green' },
                { key: 'cancel', name: 'Оставить прежнее значение', emitable: true, onEscape: true }
              ]
            })
          }
        }

        const bpState = this.bp.state
        const passiveChangesAllowed = bpState === 'VP1' || bpState === 'VP2'

        // TODO проверки и запрос изменения остальных параметров:
        const organizationReadonly = this.requestProperties.organization.accessProps.readonly
        if (vehicleGroupType.defaultOrganization && (!organizationReadonly || passiveChangesAllowed)) {
          request.organization = vehicleGroupType.defaultOrganization
        }
        const serviceTypeReadonly = this.requestProperties.serviceType.accessProps.readonly
        if (vehicleGroupType.defaultServiceType && (!serviceTypeReadonly || passiveChangesAllowed)) {
          request.serviceType = vehicleGroupType.defaultServiceType
        }
        const maxServiceDurationReadonly = this.requestProperties.maxServiceDuration.accessProps.readonly
        if (vehicleGroupType.defaultMaxServiceDuration && (!maxServiceDurationReadonly || passiveChangesAllowed)) {
          request.maxServiceDuration = vehicleGroupType.defaultMaxServiceDuration
        }
      }
    },
    onCreateVehicleGroupType: function () {
      const createConfig = {
        actualReadonly: true,
        objectParams: {
          actual: true
        }
      }

      createVehicleGroupType(this, createConfig, objectId => {
        this.getVehicleGroupTypes().then(objects => {
          const createdObject = objects.find(o => o.id === objectId)
          if (createdObject) {
            this.request.vehicleGroupType = createdObject
            this.onSelectVehicleGroupType(createdObject)
          }
        })
      })
    },
    onChangeVehicleGroupProvision: function (value) {
      if (value) {
        this.request.vehicleType = null
      } else {
        this.request.vehicleGroupType = null
      }

      const bpState = this.bp.state
      const passiveChangesAllowed = bpState === 'VP1' || bpState === 'VP2'
      // TODO проверки и запрос изменения остальных параметров:
      const organizationReadonly = this.requestProperties.organization.accessProps.readonly
      if (!organizationReadonly || passiveChangesAllowed) {
        this.request.organization = null
      }
      const serviceTypeReadonly = this.requestProperties.serviceType.accessProps.readonly
      if (!serviceTypeReadonly || passiveChangesAllowed) {
        this.request.serviceType = null
      }
      const maxServiceDurationReadonly = this.requestProperties.maxServiceDuration.accessProps.readonly
      if (!maxServiceDurationReadonly || passiveChangesAllowed) {
        this.request.maxServiceDuration = null
      }

      this.request.crewSize = null
      this.request.vehicle = null
      this.request.vehicleNote = null
      this.request.driver = null

      const isNew = this.request.id == null || this.request.id === -1
      if (isNew) {
        const vehicleProperty = this.requestProperties.vehicle
        const vehicleNoteProperty = this.requestProperties.vehicleNote
        const driverProperty = this.requestProperties.driver
        if (value) {
          vehicleProperty.readonly = true
          vehicleNoteProperty.readonly = true
          driverProperty.readonly = true
        } else {
          vehicleProperty.readonly = vehicleProperty.accessProps.readonly
          vehicleNoteProperty.readonly = vehicleNoteProperty.accessProps.readonly
          driverProperty.readonly = driverProperty.accessProps.readonly
        }
      } else {
        this.$emit('update-by-changes', {
          request: {
            vehicleGroupProvision: value
          }
        })
      }
    },
    onChangeProvidableToBrigade: function (value) {
      this.$emit('update-by-changes', {
        request: {
          providableToBrigade: value // this.request.providableToBrigade
        }
      })
    },
    onSelectOrganization: function (organization) {
      if (!this.request.vehicleGroupProvision) {
        this.clearVehicle()
        this.request.driver = null
      }
    },
    onChangeCrewSize: function (value) {
      if (value === '') {
        value = null
      } else if (typeof value === 'string') {
        value = Number(value)
      }
      this.request.crewSize = value
    },
    onSelectVehicle: function (vehicle) {
      if (vehicle) {
        if (!this.request.organization && vehicle.organization) {
          this.request.organization = vehicle.organization
        }
        if (!this.request.vehicleType && vehicle.vehicleType) {
          this.request.vehicleType = vehicle.vehicleType
        }
      }
    },
    onSelectDriver: function (employee) {
      if (employee) {
        if (!this.request.organization && employee.organization) {
          this.request.organization = employee.organization
        }
      }
    },
    clearVehicle: function () {
      this.request.vehicle = null
    },
    onVehicleCreated: async function (vehicleId) {
      const vehicles = await this.getVehicles()
      const createdVehicle = vehicles.find(v => v.id === vehicleId)
      if (createdVehicle) {
        this.request.vehicle = createdVehicle
        this.onSelectVehicle(this.request.vehicle)
      }
    },
    onDriverCreated: async function (employeeId) {
      const drivers = await this.getDrivers()
      const createdDriver = drivers.find(v => v.id === employeeId)
      if (createdDriver) {
        this.request.driver = createdDriver
        this.onSelectDriver(this.request.driver)
      }
    },
    validateFields: function (validFieldKeys) {
      validFieldKeys.forEach(validFieldKey => {
        const field = this.$refs[validFieldKey]
        if (field && field.validate) {
          field.validate()
        }
      })
    },
    getVehicleTypes: function () {
      return this.getPropertyValues('vehicleType')
    },
    getVehicleGroupTypes: function () {
      return this.getPropertyValues('vehicleGroupType')
    },
    getOrganizations: function () {
      const request = this.request

      const props = {}
      if (request.vehicleGroupProvision) {
        props.vehicleGroupProvision = request.vehicleGroupProvision

        if (request.vehicleGroupType) {
          props.vehicleGroupType = request.vehicleGroupType.id
        }
      }
      return this.getPropertyValues('organization', props)
    },
    getWorkAreas: function () {
      return this.getPropertyValues('workAreas')
    },
    getServiceTypes: function () {
      return this.getPropertyValues('serviceType')
    },
    getVehicles: function () {
      const request = this.request

      const props = {}
      if (request.organization) {
        props.organization = request.organization.id
      }
      if (request.vehicleType) {
        props.vehicleType = request.vehicleType.id
      }
      return this.getPropertyValues('vehicle', props)
    },
    getDrivers: function () {
      const request = this.request

      const props = {}
      if (request.organization) {
        props.organization = request.organization.id
      }
      return this.getPropertyValues('driver', props)
    },
    getPropertyValues: function (propertyKey, props) {
      const params = new URLSearchParams()
      params.set('property', propertyKey)
      if (props) {
        params.set('properties', JSON.stringify(props))
      }

      return axiosGet({
        url: '/service/delta/vehicleProvision/propertyValues?' + params.toString(),
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения значений параметра ' + propertyKey
      })
    },

    /**
     * Проект
     */
    getProjects: function () {
      const params = [{
        param: 'status',
        type: 'listvalue',
        action: '!=',
        value: 'nonactive'
      }]
      return this.searchObjects('project', params)
    },
    searchObjects: function (propertyKey, params) {
      const encodedParams = encodeURIComponent(JSON.stringify(params))
      return axiosGet({
        url: '/service/obj/search?params=' + encodedParams + '&nameField=name&type=' + propertyKey + '&limit=1000&sort=name',
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения значений параметра ' + propertyKey
      })
    },

    getValidateVehicleIntervalRequests: function () {
      if (!this.request.vehicle || this.request.vehicle.id == null || !this.interval.start || !this.interval.end) {
        this.vehicleIntervalRequests = []
        return
      }

      const bodyFormData = new FormData()
      if (this.request.id != -1 && this.request.id != null) {
        bodyFormData.set('id', this.request.id)
      }
      bodyFormData.set('vehicleId', this.request.vehicle.id)
      bodyFormData.set('fromTime', this.interval.start)
      bodyFormData.set('toTime', this.interval.end)

      return axiosPost({
        url: '/service/delta/vehicleProvision/validateVehicleInterval',
        data: bodyFormData,
        onSuccess: (response) => {
          this.vehicleIntervalRequests = response.data.result
        },
        onFailure: 'Ошибка получения незакрытых заявок'
      })
    }
  }
}

